import { Api } from "@/api";
import { RoleType, PaginationType, UserLoginType, PermissionType } from "@/DTO";
import { ConvertToPaginationType } from "@/api/help";
import { ConvertToRoleType } from "@/api/role/get";

export const GetPermissionList = (user: UserLoginType) => {
  return new Promise<{
    data: PermissionType[]
  }>((resolve, reject) => {
    const api = new Api({
      method: "get",
      path: `permission`,
      header: {
        Authorization: "Bearer " + user.accessToken,
        "Content-Type": "application/json"
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: data.data
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};

export const ConvertToPermissionListType = (data: any[]): PermissionType[] => {
  const returnData = data.map((item) => {
    return ConvertToPermissionType(item);
  });
  return returnData;
};

export const ConvertToPermissionType = (item: any): PermissionType => {
  return {
    group: item.group,
    permission_list: item.permission_list
  };
};


export const GetRoleList = (user: UserLoginType, pagination: PaginationType, searchData?: string) => {
  return new Promise<{
    data: RoleType[]
    pagination: PaginationType
  }>((resolve, reject) => {
    const api = new Api({
      method: "get",
      path: `role`,
      params: {
        page: pagination.currentPage,
        per_page: pagination.perPage,
        title: searchData
      },
      header: {
        Authorization: "Bearer " + user.accessToken,
        "Content-Type": "application/json"
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: ConvertToRoleListType(data.data),
          pagination: ConvertToPaginationType(data)
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};

export const ConvertToRoleListType = (data: any[]): RoleType[] => {
  const returnData = data.map((item) => {
    return ConvertToRoleType(item);
  });
  return returnData;
};

